import Alpine from "alpinejs";

Alpine.data("peopleNews", () => ({
    active: 0,
    headline: "",
    href: "",
    container: {
        "@notify"() {
            let { hover, index, slide } = this.$event.detail;
            if (hover == undefined) {
                hover = index;
            }
            this.active = hover;
            const element = slide.querySelector("a");
            this.href = element.href;
            this.headline = element.dataset.headline;
        },
    },
    link: {
        ":href"() {
            return this.href || this.$el.href;
        },
        "x-text"() {
            return this.headline || this.$el.innerText;
        },
    },
}));
